import { useContext } from "react";

import Box from "@/components/Box";
import DataLoader from "@/components/DataLoader";
import OrdersAndTests from "@/components/OrdersAndTests";
import PartnerDashboardBox from "@/components/boxes/PartnerDashboardBox";
import { ViewerContext } from "@/tpo/Viewer";
import { useTheme } from "styled-components";

import Template from "../shared/Template";
import { USER_TESTS_AND_ORDERS_QUERY } from "./graphql";
import useWardTestsAndReports from "./useWardTestsAndReports";

export default function OrdersAndTestsRoute() {
  const theme = useTheme();
  const { userId } = useContext(ViewerContext);
  const wardTestsAndReports = useWardTestsAndReports();

  return (
    <Template selectedTab="test results">
      <Box px={20}>
        <PartnerDashboardBox
          mt={theme.spacing.section.pt}
          mb={theme.spacing.section.pb}
          pt={theme.spacing.figma.medium}
          pb={theme.spacing.figma.large}
        >
          <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
            Orders
          </Box>
          <DataLoader
            query={USER_TESTS_AND_ORDERS_QUERY}
            variables={{
              allTests: true,
              excludeRetests: true,
              userId
            }}
            render={({ ordersInProgress, userTests }) => (
              <OrdersAndTests
                ordersInProgress={ordersInProgress}
                userTests={userTests}
                {...wardTestsAndReports}
                showPaymentStatus={false}
              />
            )}
          />
        </PartnerDashboardBox>
      </Box>
    </Template>
  );
}
